import {
  MotifButton,
  MotifFormField,
  MotifIcon,
  MotifSearch
} from '@ey-xd/motif-react';
  import './dataLayer.scss';
  
  export const TableHeader = ({ onFilterTextBoxChanged, searchValue, navigation }) => (
    <div className='grid-header'>
      <div className='header-input'>
        <MotifFormField>
          <MotifSearch
            aria-label='Search'
            onChange={(e) => onFilterTextBoxChanged(e.target?.value)}
            placeholder='Search for...'
            value={searchValue}
          />
        </MotifFormField>
      </div>
    </div>
  );